import { useEffect } from "react";

const PDFViewer = ({ src, isMediaContentLoaded  }) => {
  useEffect(() => {
    return(() => {
      isMediaContentLoaded(false);
    })
  }, []);

  return (
    <iframe
      title="PDF Viewer"
      src={`https://resumex.gatewaydigital.ai/django-static/pdfjs/web/viewer.html?file=${src}`}
      style={{ width: "100%", height: "90vh" }}
      sandbox="allow-same-origin allow-scripts allow-forms"
      onLoad={() => isMediaContentLoaded()}
      onError={() => isMediaContentLoaded()}
    ></iframe>
 );
};

export default PDFViewer;